import { IGeneralSettingQuery } from "../../models/general-setting/query";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer, { QueryAction } from "../base/base-reducer";
import { NotificationLoading, IInternalState } from "./context";

type Action =
  | {
      type: "LOADING";
      payload: { loading: NotificationLoading | NotificationLoading[] };
    }
  | { type: "SET_LIST"; payload: { list: any } }
  | QueryAction<IGeneralSettingQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
